import React from "react"
import PropTypes from "prop-types"
import { colors } from "themes/variables"

export const WarningIcon = ({ height = 24, width = 24, fill = colors.error, ...props }) => (
  <svg width={height} height={width} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <g clipPath="url(#clip0_9278_97543)">
      <path
        d="M9.9987 1.66683C5.39632 1.66683 1.66536 5.39779 1.66536 10.0002C1.66536 14.6025 5.39632 18.3335 9.9987 18.3335C14.6011 18.3335 18.332 14.6025 18.332 10.0002C18.332 5.39779 14.6011 1.66683 9.9987 1.66683Z"
        stroke={fill}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 6.66667V10" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 13.3335H9.99167" stroke={fill} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </g>
    <defs>
      <clipPath id="clip0_9278_97543">
        <rect width={width} height={height} fill="white" transform="matrix(-1 0 0 -1 20 20)" />
      </clipPath>
    </defs>
  </svg>
)

WarningIcon.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  fill: PropTypes.string
}
